import React from 'react'
import { Row, Col } from "react-bootstrap";
import Modal from "../../components/UI/Modal";
import { Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SettingIconBlock from '../../components/Button/SettingIconBlock';
import { cancellationStatus, getApplicationCallMe } from '../../actions';
import { useDispatch } from 'react-redux';
import { formatDate } from '../../components/FormDate';

const RenderDetailsModalCallMe = ({
    item,
    showDetailsModal,
    handleClose,
    handleDeleteById,
    typeModal,
    handleUpdateStatus,
    setType,
    role
}) => {
    const dispatch = useDispatch()

    if (!item) {
        return null;
    }
    const handleChangeOrderStatus = (e) => {
        setType(e.target.value)
    }
    const handleCancellationStatus = (text, type) => {
        const payload = {
            text,
            type
        }
        dispatch(cancellationStatus("applicationCallMe", item._id, "applicationCallMeStatus", payload))
            .then(() => (
                dispatch(getApplicationCallMe())
            ))

    }
    const onSubmit = (id) => {
        handleUpdateStatus(id)
        // handleClose()
    }
    return (
        <Modal
            show={showDetailsModal}
            handleClose={handleClose}
            modalTitle={"Детали заявки на звонок"}
            size="lg"
        >
            {typeModal === "settingModal"
                ? <div className="orderModalCenter__orderStatusMainContainer">
                    <div className="orderModalCenter__orderStatusBox">
                        {item.applicationCallMeStatus?.map((status) => (
                            <>
                                <div className={`orderModalCenter__orderStatus ${status.isCompleted ? "active" : ""}`}>
                                    {role === "superAdmin" && status.isCompleted && <SettingIconBlock
                                        icon={<CloseIcon />}
                                        tooltip="Отменить"
                                        onClick={() => handleCancellationStatus(status.text, status.type)}
                                        top="10px"
                                    />}
                                    <div className={`time ${status.isCompleted ? "active" : ""
                                        }`}>{formatDate(status.date)}</div >
                                    <span>{status.text}</span>
                                    <div className={`orderModalCenter__line ${status.isCompleted ? "active" : ""}`}>
                                    </div>
                                </div>

                            </>
                        ))}

                    </div>
                    <div className="orderModalCenter__selectBlock">
                        <div>
                            <select onChange={(e) => handleChangeOrderStatus(e)}>
                                <option value={""}>Выбрать статус</option>
                                {item.applicationCallMeStatus?.map((status) => {
                                    return (
                                        <>
                                            {!status.isCompleted ? (
                                                <option key={status.type} value={status.type}>
                                                    {status.type} {status.text}
                                                </option>
                                            ) : null}
                                        </>
                                    );
                                })}
                            </select>
                        </div>
                        <div>
                            <Button style={{ marginLeft: "10px" }} onClick={() => onSubmit(item._id)}>
                                подтвердить
                            </Button>

                        </div>
                    </div>
                </div>
                : <>
                    <div style={{
                        margin: "10px",
                    }}>
                        <button className="btn btn-secondary" onClick={handleDeleteById}>Удалить заявку</button>
                    </div>
                    <Row>
                        <Col md="6">
                            <label className="key">Полное имя</label>
                            <p className="value">{item.fullName}</p>
                        </Col>
                        <Col md="6">
                            <label className="key">Название фирмы</label>
                            <p className="value">{item.nameCompany}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <label className="key">Номер</label>
                            <div>
                                <a href='tel:' className="value">{item.contactNumber}</a>
                            </div>
                        </Col>
                        <Col md="6">
                            <label className="key">Email
                            </label>
                            <p className="value">{item.email}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <label className="key">Описание проблемы</label>
                            <p className="value">{item.descriptionProblem}</p>
                        </Col>
                        <Col>

                        </Col>
                    </Row>
                </>
            }
        </Modal>
    );
};

export default RenderDetailsModalCallMe